import { createAction } from "@ngrx/store";

export const fetchAssociatedProjects = createAction(
  'Account.FetchAssociatedProjects'
);
